// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServConfig" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { HeaderAlignment } from "./header-alignment.enum.gen";
import { TreeStatus } from "./tree-status.enum.gen";

export const SelfServConfigGenShape = z.strictObject({
  groupId: z.string(),
  teamId: z.string(),
  domain: z.string(),
  teamName: z.string().optional(),
  logoImage: z.string().optional(),
  headerAlignment: z.enum(HeaderAlignment),
  customCss: z.string().optional(),
  status: z.enum(TreeStatus),
  startText: z.string().optional(),
  contactText: z.string().optional(),
  disclaimer: z.string().optional(),
  homeLink: z.string().optional(),
  housingLink: z.string().optional(),
  feedbackLink: z.string().optional(),
  privacyLink: z.string().optional(),
  contactLink: z.string().optional(),
  hideContactBtn: z.boolean().optional(),
  selfReferralUrl: z.string().optional(),
  email: z.string().optional(),
  telephone: z.string().optional(),
  information: z.string().optional(),
  emergencyContact: z.string().optional(),
  address: z.string().optional(),
  translationUrl: z.string().optional(),
  externalDomain: z.string().optional(),
  gaKey: z.string().optional(),
  hotjarId: z.number().optional(),
  accessibleLinkText: z.boolean().optional(),
  id: z.string(),
});
